'use client';

import Script from 'next/script';

import './UsableNet.scss';

const USABLE_NET_ICON_URL = 'https://a42cdn.usablenet.com/a42/petsmart/default/prod/cs-start';

const iconParams = new URLSearchParams({
    size: 'default',
    position: 'bottom-left',
    breakpoint: '600',
    'mobile-position': 'bottom-left',
});

export const UsableNetLegacy = () => {
    const url = `${USABLE_NET_ICON_URL}?${iconParams.toString()}`;

    return (
        <Script
            id="usntA42start"
            src={url}
            data-rapid="true"
            data-testid="velocity-usablenet-script"
            data-ot-ignore
            strategy="afterInteractive"
            defer
        />
    );
};
